<ng-container *ngIf="items?.length">
	<ng-container *ngFor="let o of items">
		<div *ngIf="currentItem === o" class="item selected">{{ renderItemContent(o) }}</div>
		<div *ngIf="currentItem !== o" class="item" (click)="selectItem(o)">{{ renderItemContent(o) }}</div>
	</ng-container>
</ng-container>